import * as React from 'react';
import { RouteProps } from 'react-router';
import { IRootProps } from '../../components/RootProps';
import * as tradeInRoutes from '../../utils/routes';
import VehicleInfo from './vehicleInfo/VehicleInfo';
import TradeInDecision from './decisionPage/TradeInDecision';
import ManualEntry from './manualEntry/ManualEntry';
import TradeInSummary from './summary/Summary';
import VehicleCondition from './vehicleCondition/VehicleCondition';
import EquipmentOptionsStepOne from './equipmentOptions/EquipmentOptionsStepOne';
import EquipmentOptions from './equipmentOptions/EquipmentOptions';
import LoanBalance from './loanBalance/LoanBalance';
import EstimateLoanBalance from './EstimateLoanBalance/EstimateLoanBalance';
import LoanBalanceOptions from './loanBalanceOptions/LoanBalanceOptions';
import RegistrationDetails from './registrationDetails/RegistrationDetails';
import FindOpenLoan from './findOpenLoan/FindOpenLoan';
import LoanConfirmation from './loanConfirmation/LoanConfirmation';
import AutoLoanUnavailable from './autoLoanUnavailable/AutoLoanUnavailable';
import TradeInIco from './icoValuation/IcoValuation';
import { useStepChange } from '../hooks/useStepChange';


const MultiTradeInRouting: React.FC<IRootProps & RouteProps> = (props) => {
    const { location, tradeInRoute, onStepChange } = props;

    useStepChange(location.pathname, onStepChange);

    // For multi-trade-in, render based on currentRoute from state instead of browser URL
    const renderComponent = () => {
        // Validate that tradeInRoute is a valid route from tradeInRoutes
        const route = tradeInRoute || tradeInRoutes.TRADE_VEHICLE_INFO; // Default to TRADE_VEHICLE_INFO if tradeInRoute is not set or invalid'';

        switch (route) {
            case tradeInRoutes.TRADE_IN:
            case tradeInRoutes.TRADE_VEHICLE_INFO:
            case tradeInRoutes.TRADE_IN_EXTERNAL:
            case tradeInRoutes.TRADE_SUBARU_ELIGIBILITY:
                return <VehicleInfo {...props} />;
            case tradeInRoutes.TRADE_VEHICLE_CONDITION:
                return <VehicleCondition {...props} />;
            case tradeInRoutes.TRADE_EQUIPMENT_OPTIONS:
                return <EquipmentOptions {...props} />;
            case tradeInRoutes.TRADE_EQUIPMENT_OPTIONS_STEP_ONE:
                return <EquipmentOptionsStepOne {...props} />;
            case tradeInRoutes.TRADE_LOAN_BALANCE:
                return <LoanBalance {...props} />;
            case tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE:
                return <EstimateLoanBalance {...props} />;
            case tradeInRoutes.TRADE_LOAN_BALANCE_OPTIONS:
                return <LoanBalanceOptions {...props} />;
            case tradeInRoutes.TRADE_REGISTRATION_DETAILS:
                return <RegistrationDetails {...props} />;
            case tradeInRoutes.TRADE_FIND_OPEN_LOAN:
                return <FindOpenLoan {...props} />;
            case tradeInRoutes.TRADE_LOAN_CONFIRMATION:
                return <LoanConfirmation {...props} />;
            case tradeInRoutes.TRADE_AUTO_LOAN_UNAVAILABLE:
                return <AutoLoanUnavailable {...props} />;
            case tradeInRoutes.TRADE_IN_DECISION:
                return <TradeInDecision {...props} />;
            case tradeInRoutes.TRADE_MANUAL_ENTRY:
                return <ManualEntry {...props} />;
            case tradeInRoutes.TRADE_SUMMARY:
                return <TradeInSummary {...props} />;
            case tradeInRoutes.TRADE_IN_ICO:
                return <TradeInIco {...props} onIcoConfirmMessage={() => {}} />;
        }
    };

    return <div className="dr-p202-trade-in">{renderComponent()}</div>;
};

export default MultiTradeInRouting;
